export const CATEGORY_NAME = "catName";
export const DESCRIPTION = "catDescription";
